module.exports = __webpack_public_path__ + "img/1.7f15bd0c.png";